import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
const AboutPage = () => {
  return <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <main className="flex-grow container mx-auto px-4 py-12 max-w-4xl">
        <div className="prose prose-sm sm:prose lg:prose-lg mx-auto dark:prose-invert">
          <h1 className="text-4xl font-bold mb-8 text-center">About GetPrompts</h1>
          
          <div className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">Build Better, Build Faster.</h2>
            <p className="text-muted-foreground mb-6">
              PromptHub is the premier platform where product builders discover, share, and master AI prompts 
              that transform their workflow. We're not just a library of prompts—we're your intelligent 
              companion on the journey from concept to creation.
            </p>
          </div>
          
          <div className="mb-12">
            <h2 className="text-2xl font-semibold mb-4">Our Vision</h2>
            <p className="text-muted-foreground">
              In a world where AI is reshaping how products are built, we envision PromptHub as the essential 
              copilot for creators, developers, and entrepreneurs. We believe that the right prompt can unlock 
              extraordinary productivity, creativity, and problem-solving abilities. Our mission is to make those 
              prompts accessible, adaptable, and actionable for everyone bringing products to life.
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>;
};
export default AboutPage;